import { render, staticRenderFns } from "./ActBaseAuthGuide.vue?vue&type=template&id=2fca1e9e&scoped=true&"
import script from "./ActBaseAuthGuide.vue?vue&type=script&lang=js&"
export * from "./ActBaseAuthGuide.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseAuthGuide.vue?vue&type=style&index=0&id=2fca1e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca1e9e",
  null
  
)

export default component.exports